window.REVIAL_LOCAL = {
  "layout": [
    {
      "handle": "grahamstown-reserve-de-kariega-afrique-du-sud-2025",
      "localId": "vente-04",
      "id": "vente-04",
      "x": 33.407407407407405,
      "y": 20.6864406779661,
      "w": 26,
      "z": 1,
      "ratio": 0.6688668866886689,
      "title": "Grahamstown, Réserve de Kariega, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-province-du-cap-oriental-afrique-du-sud-2023",
      "localId": "brume",
      "id": "brume",
      "x": 5.862222222222222,
      "y": 25.910234567901224,
      "w": 19.016296296296296,
      "z": 1,
      "ratio": 0.6688668866886689,
      "title": "Grahamstown, Province du Cap-Oriental, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-reserve-de-kariega-afrique-du-sud-2024",
      "localId": "vente-03",
      "id": "vente-03",
      "x": 68,
      "y": 2,
      "w": 28,
      "z": 1,
      "ratio": 0.6688668866886689,
      "title": "Grahamstown, Réserve de Kariega, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-reserve-de-kariega-afrique-du-sud-2023",
      "localId": "vente-02",
      "id": "vente-02",
      "x": 6,
      "y": 2,
      "w": 24,
      "z": 1,
      "ratio": 0.6688668866886689,
      "title": "Grahamstown, Réserve de Kariega, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-province-du-cap-oriental-afrique-du-sud-2024",
      "localId": "vente-12",
      "id": "vente-12",
      "x": 14.21185185185185,
      "y": 43.95214005883503,
      "w": 16.799999999999997,
      "z": 1,
      "ratio": 1.4958847736625513,
      "title": "Grahamstown, Province du Cap-Oriental, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-province-du-cap-oriental-afrique-du-sud-2025",
      "localId": "vente-13",
      "id": "vente-13",
      "x": 63.70888888888889,
      "y": 57.859231406883424,
      "w": 30,
      "z": 1,
      "ratio": 0.6688668866886689,
      "title": "Grahamstown, Province du Cap-Oriental, Afrique du Sud, 2023"
    },
    {
      "handle": "grahamstown-reserve-de-kariega-afrique-du-sud-2026",
      "localId": "vente-09",
      "id": "vente-09",
      "x": 72.06888888888889,
      "y": 24.14662565554285,
      "w": 21.639999999999997,
      "z": 1,
      "ratio": 1.4958847736625513,
      "title": "Grahamstown, Réserve de Kariega, Afrique du Sud, 2023"
    },
    {
      "handle": "rapenburg-amsterdam-pays-bas-2023",
      "localId": "864d5813-a627-4f31-9f91-850af5971cef",
      "id": "864d5813-a627-4f31-9f91-850af5971cef",
      "x": 12.597094985535197,
      "y": 69.86440071387628,
      "w": 19.84734945890925,
      "z": 2,
      "ratio": 0.6688668866886689,
      "title": "Rapenburg, Amsterdam, Pays-Bas, 2023"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2026",
      "localId": "vente-25",
      "id": "vente-25",
      "x": 8,
      "y": 111.57482513816555,
      "w": 22,
      "z": 3,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2024",
      "localId": "vente-14",
      "id": "vente-14",
      "x": 37.767120361328125,
      "y": 97.12005554884726,
      "w": 17.280574092158567,
      "z": 4,
      "ratio": 0.75,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2025",
      "localId": "vente-24",
      "id": "vente-24",
      "x": 63.80592592592589,
      "y": 111.07612232315822,
      "w": 30.842962962962986,
      "z": 5,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2028",
      "localId": "vente-27",
      "id": "vente-27",
      "x": 3.5451851851851828,
      "y": 146.45815874180022,
      "w": 21.333333333333336,
      "z": 11,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2027",
      "localId": "vente-26",
      "id": "vente-26",
      "x": 32.09333333333331,
      "y": 134.35285661899542,
      "w": 31.813333333333343,
      "z": 12,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2029",
      "localId": "vente-35",
      "id": "vente-35",
      "x": 58.70888888888889,
      "y": 159.33544554455463,
      "w": 31.925925925925924,
      "z": 13,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "le-rozier-lozere-france-2025",
      "localId": "vente-19",
      "id": "vente-19",
      "x": 10,
      "y": 206.31206453978731,
      "w": 24,
      "z": 14,
      "ratio": 1.4954732510288067,
      "title": "Le Rozier, Lozère, France, 2024"
    },
    {
      "handle": "foret-notre-dame-ile-de-france-france-2030",
      "localId": "vente-36",
      "id": "vente-36",
      "x": 25.493333333333332,
      "y": 182.13439269852927,
      "w": 15.680000000000003,
      "z": 15,
      "ratio": 0.6673728813559322,
      "title": "Forêt Notre-Dame, Île-de-France, France, 2024"
    },
    {
      "handle": "le-rozier-lozere-france-2024",
      "localId": "vente-15",
      "id": "vente-15",
      "x": 56,
      "y": 188.23799046571324,
      "w": 24,
      "z": 16,
      "ratio": 0.6688668866886689,
      "title": "Le Rozier, Lozère, France, 2024"
    },
    {
      "handle": "le-rozier-lozere-france-2026",
      "localId": "vente-20",
      "id": "vente-20",
      "x": 59.407407407407405,
      "y": 211.95746241290794,
      "w": 20,
      "z": 18,
      "ratio": 0.6688668866886689,
      "title": "Le Rozier, Lozère, France, 2024"
    },
    {
      "handle": "le-rozier-lozere-france-2027",
      "localId": "vente-40",
      "id": "vente-40",
      "x": 41.403427734375,
      "y": 236.02516038130537,
      "w": 29.193144531250002,
      "z": 19,
      "ratio": 0.8584876058989646,
      "title": "Le Rozier, Lozère, France, 2024"
    },
    {
      "handle": "4ᵉ-arrondissement-paris-france-2027",
      "localId": "vente-17",
      "id": "vente-17",
      "x": 6,
      "y": 297.0068451289573,
      "w": 24,
      "z": 20,
      "ratio": 1.4958847736625513,
      "title": "4ᵉ arrondissement, Paris, France, 2024"
    },
    {
      "handle": "4ᵉ-arrondissement-paris-france-2024",
      "localId": "figure-i",
      "id": "figure-i",
      "x": 68,
      "y": 273.4142525363647,
      "w": 20,
      "z": 21,
      "ratio": 0.6694444444444444,
      "title": "4ᵉ arrondissement, Paris, France, 2024"
    },
    {
      "handle": "4ᵉ-arrondissement-paris-france-2025",
      "localId": "vente-16",
      "id": "vente-16",
      "x": 38,
      "y": 288.19203031414247,
      "w": 24,
      "z": 22,
      "ratio": 0.6688668866886689,
      "title": "4ᵉ arrondissement, Paris, France, 2024"
    },
    {
      "handle": "4ᵉ-arrondissement-paris-france-2023",
      "localId": "1f3f92d0-529b-4a69-9b03-2674cd8c2f1c",
      "id": "1f3f92d0-529b-4a69-9b03-2674cd8c2f1c",
      "x": 6,
      "y": 350.9080796968585,
      "w": 24,
      "z": 23,
      "ratio": 1.5091610414657666,
      "title": "4ᵉ arrondissement, Paris, France, 2023"
    },
    {
      "handle": "4ᵉ-arrondissement-paris-france-2026",
      "localId": "vente-18",
      "id": "vente-18",
      "x": 70.63481481481482,
      "y": 314.95746241290794,
      "w": 20,
      "z": 24,
      "ratio": 1.8790072388831438,
      "title": "4ᵉ arrondissement, Paris, France, 2024"
    },
    {
      "handle": "financial-district-new-york-etats-unis-2024",
      "localId": "lisiere",
      "id": "lisiere",
      "x": 68,
      "y": 356.9080796968585,
      "w": 24,
      "z": 25,
      "ratio": 0.66875,
      "title": "Financial District, New York, États-Unis, 2024"
    },
    {
      "handle": "midtown-east-new-york-etats-unis-2024",
      "localId": "ronces",
      "id": "ronces",
      "x": 5.862222222222222,
      "y": 394.7190873489298,
      "w": 24,
      "z": 26,
      "ratio": 0.6694444444444444,
      "title": "Midtown East, New York, États-Unis, 2024"
    },
    {
      "handle": "eglise-saint-eustache-1er-arrondissement-paris-france-2024",
      "localId": "vente-01",
      "id": "vente-01",
      "x": 36.647613525390625,
      "y": 351.6979770636177,
      "w": 22.239013671875,
      "z": 27,
      "ratio": 0.75,
      "title": "Église Saint-Eustache, 1er arrondissement, Paris, France, 2024"
    },
    {
      "handle": "saint-tropez-sud-de-la-france-france-2023",
      "localId": "d34e466c-43c0-44f4-9b54-1d69c35010e3",
      "id": "d34e466c-43c0-44f4-9b54-1d69c35010e3",
      "x": 39.03703703703704,
      "y": 64.57551182498739,
      "w": 16.38370370370375,
      "z": 28,
      "ratio": 1.4958847736625513,
      "title": "Saint-Tropez, Sud de la France, France, 2023"
    },
    {
      "handle": "carnegie-hill-new-york-etats-unis-2024",
      "localId": "rivage",
      "id": "rivage",
      "x": 58.97185185185183,
      "y": 388.57785078979,
      "w": 31.400000000000027,
      "z": 30,
      "ratio": 1.414516129032258,
      "title": "Carnegie Hill, New York, États-Unis, 2024"
    },
    {
      "handle": "cape-town-afrique-du-sud-2023",
      "localId": "vente-06",
      "id": "vente-06",
      "x": 11.851851851851851,
      "y": 438.6891574760141,
      "w": 43.85185185185185,
      "z": 32,
      "ratio": 0.6688668866886689,
      "title": "Cape Town, Afrique du Sud, 2023"
    },
    {
      "handle": "cape-town-afrique-du-sud-2024",
      "localId": "vente-08",
      "id": "vente-08",
      "x": 18,
      "y": 477.652120438977,
      "w": 24,
      "z": 34,
      "ratio": 0.6687518617813524,
      "title": "Cape Town, Afrique du Sud, 2023"
    },
    {
      "handle": "sans-titre",
      "localId": "vente-10",
      "id": "vente-10",
      "x": 9.407407407407405,
      "y": 496.8540998755913,
      "w": 30.59259259259259,
      "z": 35,
      "ratio": 1.5091610414657666,
      "title": "Sans titre"
    },
    {
      "handle": "marrakech-maroc-2024",
      "localId": "figure-ii",
      "id": "figure-ii",
      "x": 68,
      "y": 544.2455492645518,
      "w": 13.524169379340275,
      "z": 36,
      "ratio": 0.6666666666666666,
      "title": "Marrakech, Maroc, 2024"
    },
    {
      "handle": "kirkwood-eastern-cape-afrique-du-sud-2025",
      "localId": "f2b55364-2ab5-42c5-af2d-942ebff9ac23",
      "id": "f2b55364-2ab5-42c5-af2d-942ebff9ac23",
      "x": 51.70888888888889,
      "y": 515.9854537723104,
      "w": 24,
      "z": 37,
      "ratio": 0.5625835189309577,
      "title": "Kirkwood, Eastern Cape, Afrique du Sud, 2025"
    },
    {
      "handle": "nikko-prefecture-de-tochigi-japon-2025",
      "localId": "vente-28",
      "id": "vente-28",
      "x": 8,
      "y": 549.9283288507786,
      "w": 30.74074074074074,
      "z": 38,
      "ratio": 0.75,
      "title": "Nikkō, préfecture de Tochigi, Japon, 2025"
    },
    {
      "handle": "immersion",
      "localId": "immersion",
      "id": "immersion",
      "x": 63.70888888888889,
      "y": 562.6320325544823,
      "w": 24,
      "z": 40,
      "ratio": 0.6673728813559322,
      "title": "Ōmorinachi, Tokyo, Japon, 2025"
    },
    {
      "handle": "ishigaki-prefecture-d-okinawa-japon-2025",
      "localId": "vente-32",
      "id": "vente-32",
      "x": 6,
      "y": 607.6320325544823,
      "w": 24,
      "z": 41,
      "ratio": 0.6656626506024096,
      "title": "Ishigaki, préfecture d’Okinawa, Japon, 2025"
    },
    {
      "handle": "shinjuku-tokyo-japon-2025",
      "localId": "vente-30",
      "id": "vente-30",
      "x": 68,
      "y": 613.6320325544823,
      "w": 24,
      "z": 43,
      "ratio": 0.75,
      "title": "Shinjuku, Tokyo, Japon, 2025"
    },
    {
      "handle": "ebisu-tokyo-japon-2025",
      "localId": "clairiere",
      "id": "clairiere",
      "x": 5.119235228331732,
      "y": 627.3264339228465,
      "w": 34.985233247040235,
      "z": 44,
      "ratio": 1.2665360117589417,
      "title": "Ebisu, Tokyo, Japon, 2025"
    },
    {
      "handle": "omorinachi-tokyo-japon-2025",
      "localId": "vente-33",
      "id": "vente-33",
      "x": 55.04769445348669,
      "y": 591.9721360907436,
      "w": 30.661683778234075,
      "z": 45,
      "ratio": 0.6673728813559322,
      "title": "Ōmorinachi, Tokyo, Japon, 2025"
    },
    {
      "handle": "ebisu-tokyo-japon-2026",
      "localId": "vente-34",
      "id": "vente-34",
      "x": 68,
      "y": 647.6489817070246,
      "w": 24,
      "z": 46,
      "ratio": 0.6673728813559322,
      "title": "Ebisu, Tokyo, Japon, 2025"
    },
    {
      "handle": "omorinachi-tokyo-japon-2026",
      "localId": "vente-39",
      "id": "vente-39",
      "x": 33.75714111328125,
      "y": 674.5262020389953,
      "w": 32.4857177734375,
      "z": 47,
      "ratio": 1.4147355912061794,
      "title": "Ōmorinachi, Tokyo, Japon, 2025"
    },
    {
      "handle": "fujikawaguchiko-prefecture-de-yamanashi-japon-2025",
      "localId": "vente-37",
      "id": "vente-37",
      "x": 68,
      "y": 681.665930859567,
      "w": 24,
      "z": 49,
      "ratio": 1.3940425531914893,
      "title": "Fujikawaguchiko, préfecture de Yamanashi, Japon, 2025"
    },
    {
      "handle": "atoll-de-seenu-maldives-2024",
      "localId": "vente-22",
      "id": "vente-22",
      "x": 29.611851851851846,
      "y": 722.4447181171269,
      "w": 48.1552361396304,
      "z": 50,
      "ratio": 0.75,
      "title": "Atoll de Seenu, Maldives, 2024"
    },
    {
      "handle": "brooklyn-new-york-etats-unis-2024",
      "localId": "45d02043-637d-42f5-bc89-d25b94c93263",
      "id": "45d02043-637d-42f5-bc89-d25b94c93263",
      "x": 62.547407407407384,
      "y": 474.5204431103863,
      "w": 23.359999999999978,
      "z": 52,
      "ratio": 0.6688668866886689,
      "title": "Brooklyn, New York, États-Unis, 2024"
    }
  ],
  "localWallHeight": 764.5611452218496,
  "a4Frames": {
    "vente-28": {
      "image": "vente-28-a4-frame.png",
      "width": 700,
      "height": 930
    }
  },
  "a3Frames": {
    "1f3f92d0-529b-4a69-9b03-2674cd8c2f1c": {
      "image": "1f3f92d0-529b-4a69-9b03-2674cd8c2f1c-cadre-a3-hq-3600x3000.webp",
      "model": "1f3f92d0-529b-4a69-9b03-2674cd8c2f1c-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "45d02043-637d-42f5-bc89-d25b94c93263": {
      "image": "45d02043-637d-42f5-bc89-d25b94c93263-cadre-a3-hq-3600x3000.webp",
      "model": "45d02043-637d-42f5-bc89-d25b94c93263-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "864d5813-a627-4f31-9f91-850af5971cef": {
      "image": "864d5813-a627-4f31-9f91-850af5971cef-cadre-a3-hq-3600x3000.webp",
      "model": "864d5813-a627-4f31-9f91-850af5971cef-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "brume": {
      "image": "brume-cadre-a3-hq-3600x3000.webp",
      "model": "brume-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "clairiere": {
      "image": "clairiere-cadre-a3-hq-3600x3000.webp",
      "model": "clairiere-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "d34e466c-43c0-44f4-9b54-1d69c35010e3": {
      "image": "d34e466c-43c0-44f4-9b54-1d69c35010e3-cadre-a3-hq-3600x3000.webp",
      "model": "d34e466c-43c0-44f4-9b54-1d69c35010e3-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "f2b55364-2ab5-42c5-af2d-942ebff9ac23": {
      "image": "f2b55364-2ab5-42c5-af2d-942ebff9ac23-cadre-a3-hq-3600x3000.webp",
      "model": "f2b55364-2ab5-42c5-af2d-942ebff9ac23-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "figure-i": {
      "image": "figure-i-cadre-a3-hq-3600x3000.webp",
      "model": "figure-i-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "figure-ii": {
      "image": "figure-ii-cadre-a3-hq-3600x3000.webp",
      "model": "figure-ii-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "immersion": {
      "image": "immersion-cadre-a3-hq-3600x3000.webp",
      "model": "immersion-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "lisiere": {
      "image": "lisiere-cadre-a3-hq-3600x3000.webp",
      "model": "lisiere-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "rivage": {
      "image": "rivage-cadre-a3-hq-3600x3000.webp",
      "model": "rivage-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "ronces": {
      "image": "ronces-cadre-a3-hq-3600x3000.webp",
      "model": "ronces-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-01": {
      "image": "vente-01-cadre-a3-hq-3600x3000.webp",
      "model": "vente-01-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-02": {
      "image": "vente-02-cadre-a3-hq-3600x3000.webp",
      "model": "vente-02-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-03": {
      "image": "vente-03-cadre-a3-hq-3600x3000.webp",
      "model": "vente-03-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-04": {
      "image": "vente-04-cadre-a3-hq-3600x3000.webp",
      "model": "vente-04-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-06": {
      "image": "vente-06-cadre-a3-hq-3600x3000.webp",
      "model": "vente-06-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-08": {
      "image": "vente-08-cadre-a3-hq-3600x3000.webp",
      "model": "vente-08-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-09": {
      "image": "vente-09-cadre-a3-hq-3600x3000.webp",
      "model": "vente-09-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-10": {
      "image": "vente-10-cadre-a3-hq-3600x3000.webp",
      "model": "vente-10-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-12": {
      "image": "vente-12-cadre-a3-hq-3600x3000.webp",
      "model": "vente-12-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-13": {
      "image": "vente-13-cadre-a3-hq-3600x3000.webp",
      "model": "vente-13-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-14": {
      "image": "vente-14-cadre-a3-hq-3600x3000.webp",
      "model": "vente-14-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-15": {
      "image": "vente-15-cadre-a3-hq-3600x3000.webp",
      "model": "vente-15-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-16": {
      "image": "vente-16-cadre-a3-hq-3600x3000.webp",
      "model": "vente-16-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-17": {
      "image": "vente-17-cadre-a3-hq-3600x3000.webp",
      "model": "vente-17-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-18": {
      "image": "vente-18-cadre-a3-hq-3600x3000.webp",
      "model": "vente-18-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-19": {
      "image": "vente-19-cadre-a3-hq-3600x3000.webp",
      "model": "vente-19-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-20": {
      "image": "vente-20-cadre-a3-hq-3600x3000.webp",
      "model": "vente-20-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-22": {
      "image": "vente-22-cadre-a3-hq-3600x3000.webp",
      "model": "vente-22-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-24": {
      "image": "vente-24-cadre-a3-hq-3600x3000.webp",
      "model": "vente-24-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-25": {
      "image": "vente-25-cadre-a3-hq-3600x3000.webp",
      "model": "vente-25-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-26": {
      "image": "vente-26-cadre-a3-hq-3600x3000.webp",
      "model": "vente-26-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-27": {
      "image": "vente-27-cadre-a3-hq-3600x3000.webp",
      "model": "vente-27-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-28": {
      "image": "vente-28-cadre-a3-hq-3600x3000.webp",
      "model": "vente-28-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-30": {
      "image": "vente-30-cadre-a3-hq-3600x3000.webp",
      "model": "vente-30-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-32": {
      "image": "vente-32-cadre-a3-hq-3600x3000.webp",
      "model": "vente-32-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-33": {
      "image": "vente-33-cadre-a3-hq-3600x3000.webp",
      "model": "vente-33-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-34": {
      "image": "vente-34-cadre-a3-hq-3600x3000.webp",
      "model": "vente-34-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-35": {
      "image": "vente-35-cadre-a3-hq-3600x3000.webp",
      "model": "vente-35-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-36": {
      "image": "vente-36-cadre-a3-hq-3600x3000.webp",
      "model": "vente-36-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    },
    "vente-37": {
      "image": "vente-37-cadre-a3-hq-3600x3000.webp",
      "model": "vente-37-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-39": {
      "image": "vente-39-cadre-a3-hq-3600x3000.webp",
      "model": "vente-39-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 1167,
        "y": 605,
        "width": 1265,
        "height": 1788
      }
    },
    "vente-40": {
      "image": "vente-40-cadre-a3-hq-3600x3000.webp",
      "model": "vente-40-papier-a3-cadre.glb",
      "width": 3600,
      "height": 3000,
      "bounds": {
        "x": 905,
        "y": 867,
        "width": 1788,
        "height": 1265
      }
    }
  }
};
